const IconChangeLanguage = ({
  fill = "#80768d",
  width = "20",
  height = "20",
  className = "",
}) => {
  return (
    <svg
      viewBox="0 0 32 32"
      width={width}
      height={height}
      className={className ? className : null}
      data-name="IconChangeLanguage"
    >
      <path
        fill={fill}
        d="M16 0h-0.015c0 0 0 0-0.008 0h-0.015c-8.823 0.023-15.962 7.177-15.962 16s7.138 15.977 15.962 16h0.038c8.838 0 16-7.162 16-16s-7.162-16-16-16v0zM16 30.723h-0.015c0 0 0 0-0.008 0h-0.015c-8.108-0.023-14.685-6.608-14.685-14.723s6.569-14.7 14.685-14.715h0.038c8.131 0 14.723 6.592 14.723 14.723 0 8.123-6.592 14.715-14.723 14.715v0z"
      />
      <path
        fill={fill}
        d="M21.1 9.523c-1.438 0.346-2.923 0.554-4.454 0.6v5.238h5.2c-0.046-2.162-0.315-4.123-0.746-5.838v0z"
      />
      <path
        fill={fill}
        d="M16.638 2.654v6.3c1.423-0.046 2.808-0.231 4.138-0.554-1.008-3.185-2.577-5.277-4.138-5.746v0z"
      />
      <path
        fill={fill}
        d="M11.185 8.392c1.346 0.323 2.738 0.515 4.169 0.562v-6.315c-1.562 0.454-3.154 2.546-4.169 5.754v0z"
      />
      <path
        fill={fill}
        d="M25.585 6.569c-1.738-1.769-3.962-3.062-6.454-3.654 1.138 1.177 2.092 2.977 2.777 5.177 1.285-0.392 2.515-0.9 3.677-1.523v0z"
      />
      <path
        fill={fill}
        d="M23.023 15.362h6.408c-0.138-2.985-1.254-5.723-3.038-7.892-1.315 0.723-2.708 1.315-4.162 1.754 0.469 1.846 0.746 3.931 0.792 6.138v0z"
      />
      <path
        fill={fill}
        d="M10.115 15.362h5.246v-5.238c-1.546-0.046-3.046-0.254-4.492-0.608-0.438 1.715-0.708 3.685-0.754 5.846v0z"
      />
      <path
        fill={fill}
        d="M21.846 16.638h-5.208v5.231c1.531 0.046 3.023 0.246 4.462 0.6 0.431-1.708 0.7-3.677 0.746-5.831v0z"
      />
      <path
        fill={fill}
        d="M10.869 22.477c1.446-0.354 2.946-0.562 4.492-0.608v-5.231h-5.246c0.046 2.162 0.315 4.131 0.754 5.838v0z"
      />
      <path
        fill={fill}
        d="M15.362 29.354v-6.315c-1.431 0.046-2.831 0.238-4.177 0.562 1.015 3.208 2.608 5.308 4.177 5.754v0z"
      />
      <path
        fill={fill}
        d="M19.131 29.085c2.492-0.6 4.715-1.885 6.462-3.662-1.162-0.623-2.392-1.131-3.677-1.523-0.685 2.208-1.646 4-2.785 5.185v0z"
      />
      <path
        fill={fill}
        d="M12.823 2.931c-2.469 0.6-4.677 1.885-6.408 3.646 1.154 0.615 2.369 1.123 3.638 1.508 0.685-2.192 1.638-3.977 2.769-5.154v0z"
      />
      <path
        fill={fill}
        d="M22.231 22.777c1.462 0.438 2.854 1.031 4.169 1.754 1.785-2.169 2.9-4.908 3.038-7.892h-6.408c-0.054 2.208-0.331 4.285-0.8 6.138v0z"
      />
      <path
        fill={fill}
        d="M16.638 23.038v6.308c1.562-0.469 3.131-2.562 4.138-5.754-1.331-0.323-2.715-0.508-4.138-0.554v0z"
      />
      <path
        fill={fill}
        d="M9.738 9.215c-1.446-0.438-2.831-1.023-4.131-1.746-1.785 2.169-2.9 4.908-3.038 7.892h6.377c0.038-2.215 0.323-4.3 0.792-6.146v0z"
      />
      <path
        fill={fill}
        d="M8.938 16.638h-6.377c0.138 2.985 1.254 5.723 3.038 7.892 1.3-0.715 2.685-1.308 4.131-1.746-0.462-1.846-0.746-3.931-0.792-6.146v0z"
      />
      <path
        fill={fill}
        d="M6.408 25.423c1.731 1.762 3.938 3.046 6.415 3.646-1.131-1.177-2.085-2.969-2.769-5.162-1.269 0.392-2.492 0.9-3.646 1.515v0z"
      />
    </svg>
  );
};
export default IconChangeLanguage;
